import { fleetDefaultFilters } from '../constants/FleetDefaultFilters';
import { AUTH_LOGIN, FLEET_LOADED, SET_FLEET_OVERRIDE } from '../constants/action-types';
import { Fleet } from '../interfaces';
import { AppState } from '../reducers';
import { setDefaultFilter, updateFilterPartial } from '../queries';
import { FleetService, UserService } from '../services';

export function setLoadedFleet(fleet: Fleet) {
  return {
    type: FLEET_LOADED,
    fleet,
  };
}

export function refreshFleet(isInit?: boolean) {
  return function (dispatch: any, getState: () => AppState) {
    const { store } = getState();

    UserService.isInternal()
      .then((isInternal) => {
        const fleetIdFromUrl = new URL(document.URL).searchParams.get('fleet_id');
        if (fleetIdFromUrl) {
          dispatch(setFleetOverride(fleetIdFromUrl)); // it updates fleetooverride when we got different fleet from link.
          // Unnecessary, but it better to make current state in sync
        }
        const fleetId = fleetIdFromUrl || store.currentSelectedFleetID;

        if (isInternal && fleetId) {
          return FleetService.get(fleetId);
        }
        return FleetService.getMyFleet();
      })
      .then((fleet) => {
        if (isInit) {
          setDefaultFilter(fleet.id);
        } else {
          updateFilterPartial(fleetDefaultFilters(fleet.id));
        }
        dispatch(setLoadedFleet(fleet));

        // only dispatch the login action if we're initializing the app - and make it AFTER the fleet is loaded
        // so that all components of the app can access the fleet object
        if (isInit) {
          dispatch({
            type: AUTH_LOGIN,
            isAuthenticated: true, // todo: make normal actions for app init and separate fleet update from auth logic
          });
        }
      });
  };
}

export function setFleetOverride(fleetID: string) {
  return {
    type: SET_FLEET_OVERRIDE,
    fleetID,
  };
}
